// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import layer from 'vue-layer'
// import cropper from 'vue-cropper'

Vue.prototype.$ajax = axios;

Vue.prototype.$layer = layer(Vue);
// Vue.prototype.$refs = cropper(Vue);

import jquery from './assets/js/jquery.js'

// import index from './assets/js/zm-canvas-crop.js'
import index from './assets/js/zm-canvas-crop.js'
import layerJs from './assets/layer/layer.js'
import layerCss from './assets/layer/theme/default/layer.css'
Vue.use(index);


// import crop from './assets/js/zm-canvas-crop.js'

// import jqueryUiJs from './assets/js/jquery-ui.js'
// import bootstrapJs from './assets/js/bootstrap.js'
// import commonJs from './assets/js/common.js'
// import popoverJs from './assets/js/popover.js'
// import printareaJs from './assets/js/jquery.printarea.js'


// import bootstrapCss from './assets/css/bootstrap.css'
// import jqueryUiCss from './assets/css/jquery-ui.css'
// import popoverCss from './assets/css/popover.css'
import baseCss from './assets/css/base.scss'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js